import * as React from 'react';
import ManutationPanel from '../manutationpanel';

export function FgtsManutation() {
  return (<div style={{ textAlign: 'center' }}>
    <ManutationPanel
      endpointBase="/server/fgtsCommand/botManutation"
      systemLabel="FGTS"
      showShot
    />
  </div>);
}
